import * as React from 'react';

import SuperCritical from 'lib/supercritical';

import { TitledTab } from 'portcall/pctabstrip/model';

import {
    CancelledCoordinationCardDetails,
    TabLog,
    TabSettings
} from './cancelled';

import {
    PCTabContents,
    PCTabStripView,
    TitledTabContentsController,
    TitledTabStripViewController
} from 'portcall/pctabstrip/view';

import { CancelledCoordinationCardDetailsSettingsTabView as SettingsTabView } from './cancelledsettingsview';
import { CoordinationCardDetailsLogTabView as LogTabView } from './logview';
import {
    CoordinationCardDetailsCloseLink,
    CoordinationCardDetailsLoadingIcon
} from './view';

export const CancelledCoordinationCardDetailsView = SuperCritical(({ model: m } : { model : CancelledCoordinationCardDetails }) =>
    <div className="cancelledcoordinationcarddetails">
        <PCTabStripView
            model={m.TabStrip}
            ctrl={new TitledTabStripViewController()}
            extraContents={() =>
                <CoordinationCardDetailsCloseLink dismissDetails={m.DismissDetails} />
            }
        />
        <PCTabContents
            model={m.TabStrip}
            ctrl={new TabContentsController(m)}
        />
        <CoordinationCardDetailsLoadingIcon loading={m.Loading} />
    </div>
);

class TabContentsController extends TitledTabContentsController {
    constructor(readonly model : CancelledCoordinationCardDetails) { super(); }

    renderTabContents(tab : TitledTab) {
        const m = this.model;
        if      (tab === TabLog     ) return <LogTabView model={m.LogTab} />;
        else if (tab === TabSettings) return <SettingsTabView model={m.SettingsTab} />;
        else throw new Error(`Unknown tab with title '${tab.Title}'`);
    }
}



// WEBPACK FOOTER //
// ./apps/portcall/coordinationcarddetails/cancelledview.tsx